import { render } from "./EditModal.vue?vue&type=template&id=67f9e4c7&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"

import "./EditModal.vue?vue&type=style&index=0&id=67f9e4c7&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f9e4c7"]])

export default __exports__